import { useState } from 'react';

type Props<T> = {
  title: string;
  columns: Array<{ header: string; render: (row: T) => React.ReactNode }>;
  rows: T[];
  initialVisible?: number;
  expandLabel?: (total: number) => string;
};

export default function ExpandableTable<T>({
  title,
  columns,
  rows,
  initialVisible = 5,
  expandLabel,
}: Props<T>) {
  const [expanded, setExpanded] = useState(false);
  const showExpand = rows.length > initialVisible;

  return (
    <div className="pages-table">
      <div className="pages-table-header">{title}</div>
      <table className={`expandable-table ${expanded ? 'expanded' : ''}`}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.header}>{c.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className={i >= initialVisible ? 'hidden-row' : ''}>
              {columns.map((c) => (
                <td key={c.header}>{c.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {showExpand && (
        <button className="table-expand-btn" onClick={() => setExpanded((v) => !v)}>
          {expanded
            ? 'Hide rows'
            : (expandLabel?.(rows.length) ?? `Show all ${rows.length} rows`)}
          <span className="arrow">▼</span>
        </button>
      )}
    </div>
  );
}
